/**
 * @name copyToClipboard
 * @description Copy a value to the users clipboard.
 */
export const copyToClipboard = (value: string): void => {
  const el = document.createElement('textarea');

  el.value = value;
  el.style.fontSize = '16px';

  window.document.body.appendChild(el);

  el.select();

  window.document.execCommand('copy');
  window.document.body.removeChild(el);
};
